import React from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import { useBrowserWidth, useIsMobile } from '../../hooks';
import { UI_ROUTES } from '../../util/routes';

import styles from './Grid.module.scss';

type Props = {
    notificationArea?: React.ReactNode;
    children: React.ReactNode;
    extraChildren?: React.ReactNode;
    className?: string;
    /** Screens that draw their own top element under the fixed mobile header. */
    hideSymbolDetailsMarginTop?: boolean;
}

const Grid: React.FC<Props> = ({
  notificationArea,
  children,
  extraChildren,
  className,
  hideSymbolDetailsMarginTop,
}) => {
  const { isMobile } = useIsMobile();
  const { browserWidthSize } = useBrowserWidth();
  const location = useLocation();

  // The mobile header is fixed, so the main pages clear it here rather than each
  // of them repeating the offset.
  const isMainPage = location.pathname.includes(UI_ROUTES.overview)
    || location.pathname.includes(UI_ROUTES.discover)
    || location.pathname.includes(UI_ROUTES.dashboard)
    || location.pathname.includes(UI_ROUTES.payouts)
    || location.pathname.includes(UI_ROUTES.referrals)
    || location.pathname.includes(UI_ROUTES.symbol)
    || location.pathname.includes(UI_ROUTES.planDetails);

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.grid}>
        {!(!extraChildren && notificationArea && browserWidthSize > 1280) && (
        <div>
          {notificationArea}
        </div>
        )}
        <div className={styles.gridBody}>
          <div className={classNames(styles.gridContent, {
            [styles.gridContentMobile]: isMobile && !extraChildren,
            [styles.gridContentFullWidth]: !isMobile && !extraChildren,
            [styles.gridContentMarginTopMobile]: isMobile && isMainPage && !hideSymbolDetailsMarginTop,
          },
          className)}
          >
            {children}
          </div>
          {extraChildren && (
          <div className={styles.gridExtraContent}>
            {extraChildren}
          </div>
          )}
          {!extraChildren && notificationArea && !isMobile && browserWidthSize > 1280 && (
            <div className={classNames(styles.gridExtraContent, styles.smallNotificationsWidth)}>
              {notificationArea}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Grid;
